import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { AppProvider } from "context/AppContext";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAwEDCi6C0KkLv1e1vSE9B6_I3AG6tr-Vk",
  authDomain: "devchallenges-1234.firebaseapp.com",
  databaseURL: "https://devchallenges-1234.firebaseio.com",
  projectId: "devchallenges-1234",
  storageBucket: "devchallenges-1234.appspot.com",
  messagingSenderId: "992313936602",
  appId: "1:992313936602:web:28c6dd95f385a0ee97b3e3",
  measurementId: "G-0KP4JSHXTV",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
